<template>
  <main id="archive-posts" class="section">
    <template v-if="recentPostsLoaded">
      <h2 class="title is-2">ブログ</h2>
      <div class="columns is-multiline">
        <template v-for="post in recentPosts(limit,paged)">
          <div class="column is-3">
            <post :post="post"></post>
          </div>
        </template>
      </div>

      <b-pagination order="is-centered" size="is-medium" :total="recentPostsTotal" :current.sync="current"
        :per-page="perPage" aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page"
        aria-current-label="Current page">
      </b-pagination>

      <!-- <b-pagination v-model="current" :total-rows="recentPostsTotal" :per-page="perPage" aria-controls="my-table">
          </b-pagination> -->
    </template>
    <Loader v-else />
  </main>
</template>

<script>
  // import _ from "lodash";
  import axios from "axios";
  import Loader from "../partials/Loader.vue";
  import Post from "../partials/Post.vue";
  import {
    mapGetters
  } from "vuex";
  import SETTINGS from "../../settings";
  // let paged = 1;

  export default {
    // props: ["limit"],
    data() {
      let paged = this.$route.query.paged;
      if (!paged) {
        paged = 1;
      }

      return {
        limit: 10,
        paged: paged,
        perPage: 10,
        total: 0,
        total_pages: 0,
        current: paged,
        posts: false
      };
    },
    watch: {
      '$route'() {
        let paged = this.$route.query.paged;
        if (!paged) {
          paged = 1;
        }
        this.current = paged;
      },
      current() {
        let paged = this.current;
        let arg = {}
        if (paged > 1) {
          arg.paged = paged;
        }
        this.paged = paged;

        this.$router.push({
          query: arg
        });
        this.getPosts();
      }
    },

    computed: {
      ...mapGetters({
        recentPosts: "recentPosts",
        recentPostsLoaded: "recentPostsLoaded",
        recentPostsTotal: "recentPostsTotal"
      })
    },
    mounted() {
      // this.$store.dispatch("getPosts", {
      //   limit: 10,
      //   paged: 1
      // });
      this.getPosts();
    },
    // beforeMount() {
    //   // this.getPosts();
    // },

    methods: {
      // createPostSlug: post => {
      //   let link = post.link;
      //   // let slug = post.link.replace("http://" + window.location.hostname, "");
      //   // slug = slug.replace("https://" + window.location.hostname, "");

      //   let nohost = link.split('//')[1];
      //   let slugs = nohost.split("/");

      //   slugs.shift();

      //   let slug = slugs.join('/');
      //   console.log(slug);
      //   post.slug = slug;
      //   // console.log(window.location.hostname);
      //   return post;
      // },
      getPosts: function () {
        let paged = this.$route.query.paged;
        if (!paged) {
          paged = 1;
        }
        console.log("paged", paged);
        this.paged = paged;
        this.$store.dispatch("getPosts", {
          limit: 10,
          paged: paged
        });

        // axios
        //   .get(
        //     SETTINGS.API_BASE_PATH + "posts?page=" + paged
        //   )
        //   .then(response => {
        //     let posts = response.data;
        //     posts.map((post, i) => {
        //       posts[i] = this.createPostSlug(post);
        //     });

        //     this.posts = posts;
        //     console.log(response);
        //     this.total = Number(response.headers['x-wp-total']);
        //     this.total_pages = Number(response.headers['x-wp-totalpages']);
        //     console.log(this.total);
        //   })
        //   .catch(e => {
        //     console.log(e);
        //   });
      }
    },

    components: {
      Loader,
      Post
    }
  };
</script>